/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
export const IconArrowTop = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16' {...props}>
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M7.47 2.47a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1-1.06 1.06L8.75 4.81V13a.75.75 0 0 1-1.5 0V4.81L4.78 7.28a.75.75 0 0 1-1.06-1.06z'
      clipRule='evenodd'
    />
  </svg>
)
